//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";

const TABLE_LIST_COLUMNS = [
  {
    name: "start-date",
    required: false,
    label: "Data de Início",
    align: "left",
    field: (row) => row.start_date,
    sortable: false,
  },
  {
    name: "end-date",
    required: false,
    label: "Data de Fim",
    align: "left",
    field: (row) => row.end_date,
    sortable: false,
  },
  {
    name: "product.ean",
    required: false,
    label: "EAN",
    align: "left",
    field: (row) => row.product.ean,
    sortable: false,
  },
  // {
  //   name: "product.sku",
  //   align: "left",
  //   label: "Código interno",
  //   field: (row) => row.product.sku,
  //   sortable: false,
  // },
  {
    name: "product.name",
    label: "Descrição",
    align: "left",
    field: (row) => row.product.name,
    sortable: false,
  },
  {
    name: "product.product-retailer-infos.sku",
    label: "Código SKU Retalhista",
    align: "left",
    field: (row) => (row.retailer_info ? row.retailer_info.sku : null),
    sortable: false,
  },
  {
    name: "product.product-retailer-infos.name",
    label: "Descrição Retalhista",
    align: "left",
    field: (row) => (row.retailer_info ? row.retailer_info.name : null),
    sortable: false,
  },
  {
    name: "status",
    label: "Estado",
    align: "left",
    field: (row) => row.status,
    sortable: false,
    icon: {
      conditional: true,
      0: {
        name: "mdi-close-circle-outline",
        label: "Inactivo",
        color: "red-4",
      },
      1: {
        name: "mdi-check-circle-outline",
        label: "Activo",
        color: "green-4",
      },
    },
  },
  {
    name: "store.code",
    label: "Código de loja",
    align: "left",
    field: (row) => row.store.code,
    sortable: false,
  },
  {
    name: "store.name",
    label: "Nome de loja",
    align: "left",
    field: (row) => row.store.name,
    sortable: false,
  },
  {
    name: "type",
    label: "Método de criação",
    align: "left",
    field: (row) => row.file_type,
    sortable: false,
  },
  {
    name: "product-depth",
    label: "Prof. Artigo",
    align: "left",
    field: (row) => row.product_depth,
    sortable: false,
  },
  {
    name: "store-depth",
    label: "Prof. Loja",
    align: "left",
    field: (row) => row.store_depth,
    sortable: false,
  },
];

export default {
  name: "CardexTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table,
  },
  data: function () {
    return {
      columns: TABLE_LIST_COLUMNS,
      separator: "horizontal",
      pagination: {
        rowsPerPage: 10,
      },
    };
  },
  methods: {
    renderRightSide: function (event) {
      this.$emit("clicked-row", { ...event });
    },
    updateFilter: function (event) {
      this.$emit("filter-changed", event);
    },
  },
  computed: {
    visibleColumns: function () {
      return this.columns.map((column) => column.name);
    },
    sortStatus: function () {
      return Array(this.columns.length).fill(true);
    },
    filterData: function () {
      return Object.assign(
        {},
        Array(this.columns.length)
          .fill({})
          .map((item, index) => ({
            index: index,
            colKey: this.columns[index].name,
            exclude: [""],
          }))
      );
    },
  },
};
